import {
  CLINIC_MARKETPLACE_PAGE,
  COACH_MARKETPLACE_PAGE,
  COURT_FINDER_PAGE,
  TOURNAMENTS_PAGE,
} from 'constants/pages';
import CoachBadge from 'svg/CoachBadge';
import CourtFlat from 'svg/CourtFlat';
import RacketBall from 'svg/RacketBall';
import Trophy from 'svg/Trophy';

export const exploreData = [
  {
    title: 'Play in a tournament',
    href: TOURNAMENTS_PAGE,
    icon: <Trophy className="h-8 w-8 text-color-text-lightmode-invert max-sm:h-5 max-sm:w-5" />,
    image: 'tournament.png',
  },
  {
    title: 'Find a coach',
    href: COACH_MARKETPLACE_PAGE,
    icon: <CoachBadge className="h-8 w-8 text-color-text-lightmode-invert max-sm:h-5 max-sm:w-5" />,
    image: 'coach.png',
  },
  {
    title: 'Join a clinic',
    href: CLINIC_MARKETPLACE_PAGE,
    icon: <RacketBall className="h-8 w-8 text-color-text-lightmode-invert max-sm:h-5 max-sm:w-5" />,
    image: 'clinic.png',
  },
  {
    title: 'Book a court',
    href: COURT_FINDER_PAGE,
    icon: <CourtFlat className="h-8 w-8 text-color-text-lightmode-invert max-sm:h-5 max-sm:w-5" />,
    image: 'court.png',
  },
];
